import { Alert, Box } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import { useCurrentIncidence } from 'modules/bookkeepers/lib/CurrentIncidenceContext'
import type IncidenceDetail from 'modules/bookkeepers/store/models/IncidenceDetail'
import InformationLink from 'modules/payroll_bundle/pages/IncidenceDetailPage/_MoreInformation/InformationLink'

import ReactivationDetails from './ReactivationDetails'
import { AgreementInformationFields } from './utils'

interface Props {
  incidenceDetailModel: IncidenceDetail
  hasA3innuvaFeature: boolean
  isBookkeeperView: boolean
}

const ReactivationInfo = ({
  incidenceDetailModel,
  hasA3innuvaFeature,
  isBookkeeperView = false,
}: Props) => {
  const { navigation } = useNavigation()

  const incidence = useCurrentIncidence()
  const employeeId = incidence.employeeId ?? '0'
  const companyId = incidence.legalEntity?.companyId

  const showA3nomError =
    isBookkeeperView &&
    hasA3innuvaFeature &&
    !incidenceDetailModel.attributes?.payroll_a3nom_integration_code

  return (
    <Box gap="s16">
      {showA3nomError && (
        <Alert color="warning">
          <Box flexDirection="column" gap="s8">
            {i18n.t('bookkeepers.incidence.details.a3nom_error')}
            <InformationLink
              href={`${navigation.employees.id.personal.fullPath({
                id: employeeId,
              })}?switchToCompanyId=${companyId}`}
              label={i18n.t('bookkeepers.incidence.details.see_employee_profile')}
            />
          </Box>
        </Alert>
      )}

      <ReactivationDetails
        incidenceDetailModel={incidenceDetailModel}
        title={i18n.t('bookkeepers.incidence.details.sections.agreement_information')}
        hiringFields={AgreementInformationFields}
      />
    </Box>
  )
}

export default ReactivationInfo
